<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import error from "@core/assets/icons/error.svg?raw";
	import translations from "./FathersChoiceB2cOnly.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const translate = getTranslate(translations);
</script>

<div class="flex px-3.5 gap-3.5 py-3 rounded-xl bg-fcrerror/50 border-fcrerror">
	<Icon icon={error} aria-hidden="true" class="size-4 text-fcrerror" />
	<div class="text-xs/normal font-medium">
		<Formatted text={translate("label")} />
	</div>
</div>
